import { linkStrategy, linkStrategyCTA } from '@/App.datalayer';
import { OnDatalayerProps } from '@/features/shared/HOCs/withGTM.interface';

const events = new Map([
  ['footer', 'clickFooterLink'],
  ['social', 'clickSocialLink'],
  ['livechat', 'clickLiveChat'],
]);

export const onDatalayerLegacy = ({ target }: OnDatalayerProps) => {
  const scenario = target?.getAttribute('data-datalayer-scenario');
  const variantName = target?.dataset?.datalayerVariant;
  const href = target?.href;

  if (!scenario) {
    return undefined;
  }

  const event = events.get(scenario) || events.get('footer');

  return {
    event,
    eventCategory: 'Footer',
    href,
    ...(variantName && { variant_name: variantName }),
  };
};

export const onDatalayerLiveChat = ({ target }: OnDatalayerProps) => {
  const scenario = target?.getAttribute('data-datalayer-scenario');
  const variantName = target?.dataset?.datalayerVariant || '';

  if (!scenario) return undefined;
  if (scenario !== 'livechat') return undefined;

  return {
    event: 'trackEvent-liveChatClick',
    event_name: 'chat_support_engagement',
    position: 'footer',
    chat_support_action: 'live_chat_clicked',
    ...(variantName && { variant_name: variantName }),
  };
};

export const onDatalayerClickLink = ({ target }: OnDatalayerProps) => {
  if (target?.getAttribute('data-datalayer-ignore-link')) return undefined;

  const variantName = target?.closest('[data-datalayer-variant]')?.dataset?.datalayerVariant || '';
  return linkStrategy({ target, position: 'footer', variant: variantName });
};

export const onDatalayerClickCTA = ({ target }: OnDatalayerProps) => {
  if (target?.getAttribute('data-datalayer-ignore-cta')) return undefined;

  const variantName = target?.closest('[data-datalayer-variant]')?.dataset?.datalayerVariant || '';
  return linkStrategyCTA({ target, position: 'footer', variant: variantName });
};
